module.exports = __webpack_public_path__ + "static/media/WordsHavePower_p12-13.73d7188d.jpg";